module.exports = __webpack_public_path__ + "img/1_uk.fe1f22dc.svg";